import { FC } from "react";
import AttributionDashboard from "../components/AttributionDashboard";

const AttributionDashboardPage: FC = () => {
  return <AttributionDashboard />;
};

export default AttributionDashboardPage;
